import {
  getCheckoutCoownersData,
  getQuotation,
} from 'app/services/businessFunctionHelpers';
import {
  FieldsEnum,
  FormsEnum,
  ModelPathEnum,
  PersonType,
} from 'app/shared/enums';
import { setBirthdateAndGenderByPesel } from 'app/services/businessFunctions/helpers/setBirthdateAndGenderByPesel';
import { QuotationService } from 'app/services/quotation.service';
import { validateCheckoutPesel } from 'app/services/pesel.service/validateCheckoutPesel';

const firstCoownerDetails = {
  checkoutCoowners1PeselChange() {
    const { peselCheckoutForm: pesel } = getCheckoutCoownersData()[1];
    const isPeselCorrect = validateCheckoutPesel(PersonType.Coowner1);

    if (!isPeselCorrect) {
      return;
    }

    const { id } = getQuotation();
    QuotationService.update(id, ModelPathEnum.Coowners1PeselNumber, pesel);

    setBirthdateAndGenderByPesel(
      false,
      parseInt(pesel),
      FormsEnum.CheckoutForm,
      FieldsEnum.Coowners1BirthDate,
      FieldsEnum.Coowners1Gender
    );
  },
};

export default firstCoownerDetails;
